import { useState } from "react";
import { format, parseISO, isValid } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Label } from "@/components/ui/label";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

/** ISO YYYY-MM-DD in <-> Date object, wrapped in shadcn Calendar + Popover. */
export default function DatePickerField({
  testid, label, value, onChange, minDate, disabled, className, fromYear, toYear,
}) {
  const [open, setOpen] = useState(false);
  const parsed = value ? parseISO(value) : null;
  const selected = parsed && isValid(parsed) ? parsed : undefined;
  const disabledMatcher = minDate ? { before: minDate } : undefined;

  return (
    <div className={className}>
      {label && <Label className="text-xs text-slate-600 mb-1 block">{label}</Label>}
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button data-testid={testid} type="button" variant="outline" disabled={disabled}
            className={cn("w-full justify-start h-10 text-left font-normal",
                          !selected && "text-muted-foreground")}>
            <CalendarIcon className="mr-2 h-4 w-4 text-pink-700 shrink-0" />
            {selected ? format(selected, "PPP") : <span>Pick a date</span>}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar mode="single" selected={selected} disabled={disabledMatcher}
            captionLayout="dropdown-buttons"
            fromYear={fromYear ?? 1940}
            toYear={toYear ?? new Date().getFullYear() + 10}
            onSelect={(d) => {
              if (d) onChange(format(d, "yyyy-MM-dd"));
              setOpen(false);
            }}
            initialFocus />
        </PopoverContent>
      </Popover>
    </div>
  );
}
